/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Injectable } from '@angular/core';
import { DTOMappers } from '@models/generic/dto-mappers.model';
import {
  PositionDTO,
  WizardDTO,
  SurveyDTO,
  FormDTO,
  ChecklistDTO,
  UserDataDTO,
  BankAccountEvaluationDTO,
  QuotationBoundariesDTO,
  QuotationDTO,
  NoteDTO,
  AtcDTO,
  NotificationDTO,
  WizardStepNextOutputDTO,
  CreditRequestDTO,
  CreditUseListDTO
} from '@api/models';

@Injectable({
  providedIn: 'root'
})
export class ApiResParserService implements DTOMappers {
  generic<T>(res: any): T {
    return res;
  }

  userData(res: any): UserDataDTO {
    return res;
  }

  position(res: any): PositionDTO {
    return res;
  }

  savePosition(res: any): string {
    return res;
  }

  personalPositions(res: any): PositionDTO[] {
    return !res || !(res instanceof Array) ? [] : res;
  }

  wizard(res: any): WizardDTO {
    return res;
  }

  surveys(res: any): SurveyDTO[] {
    return res;
  }

  forms(res: any): FormDTO[] {
    return res;
  }

  checklist(res: any): ChecklistDTO {
    return res;
  }

  bankAccountEvaluation(res: any): BankAccountEvaluationDTO {
    return res;
  }

  quotationBoundaries(res: any): QuotationBoundariesDTO {
    return res;
  }

  calculateQuotation(res: any): QuotationDTO {
    return res;
  }

  notes(res: any): NoteDTO[] {
    return res;
  }

  atc(res: any): AtcDTO[] {
    return res;
  }

  notifications(res: any): NotificationDTO[] {
    return res;
  }

  workflowTaskClose(res: any): WizardStepNextOutputDTO {
    return res;
  }

  quotationCreditRequest(res: any): CreditRequestDTO {
    return res;
  }

  quotationCreditUse(res: any): CreditUseListDTO {
    return res;
  }

  protected cleanPayload<T>(res: any): T {
    if (!!res && !!res.payload) {
      return res.payload;
    } else {
      return res;
    }
  }
}
